import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const imgSrc = (src) => (src && src.startsWith("http") ? src : `${BACKEND}${src}`);

export const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Algo deu errado. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const CATS = [
  { slug: "futebol", name: "Futebol" },
  { slug: "surf", name: "Surf" },
  { slug: "fitness", name: "Fitness" },
  { slug: "corrida", name: "Corrida" },
  { slug: "lutas", name: "Lutas & MMA" },
  { slug: "ciclismo", name: "Ciclismo & MTB" },
  { slug: "skate", name: "Skate" },
  { slug: "basquete", name: "Basquete" },
];

export const catName = (slug) => (slug === "todas" ? "Todas as modalidades" : CATS.find((c) => c.slug === slug)?.name || slug);

export const STATUS_LABEL = { pending: "Em análise", approved: "Aprovada", rejected: "Recusada", removed: "Removida" };
